import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdvertiserComponent } from './advertiser.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import {SharedModule} from '@rubii/frontend-common';



@NgModule({
  declarations: [AdvertiserComponent],
  imports: [
    CommonModule,
    MatInputModule,
      MatIconModule,
      SharedModule,
      MatGridListModule,
      SharedModule
  ]
})
export class AdvertiserModule { }
